/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Styles from './Renegociacao25Entenda.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function Renegociacao25Entenda() {
  return (
    <>
      <section id="renegociacao25-entenda">
        <ContainerHome24>
          <div className="entenda-conteudo">
            <img src="assets/renegociacao25/img-entenda.svg" alt="" />
            <div className="entenda-textos">
              <h2 className="entenda-titulo">
                Entenda a diferença entre renegociação e reorganização
              </h2>
              <p className="entenda-texto">
                Na Santander Financiamentos você pode renegociar o seu contrato atrasado ou
                reorganizar seu contrato em dia para facilitar a sua vida e de sua família.
              </p>
            </div>
          </div>
          <div className="entenda-quadros">
            <div className="entenda-quadro">
              <div className="entenda-quadro-textos">
                <p className="entenda-quadro-texto">
                  <strong>Seu contrato está atrasado?</strong>
                  <br />
                  Conheça a <b>renegociação</b>
                </p>
                <p className="entenda-quadro-texto">
                  Acesse o nosso portal de renegociações e consulte as ofertas que temos disponíveis
                  para você que está em atraso.
                </p>
              </div>
              <a
                href="https://santanderfinanciamentos.com.br/portalcliente/login"
                target="_blank"
                className="entenda-quadro-link"
              >
                Renegociar
              </a>
              <div className="entenda-quadro-separador mobile">x</div>
            </div>
            <div className="entenda-quadro-separador desktop">x</div>
            <div className="entenda-quadro quadro-2">
              <div className="entenda-quadro-textos">
                <p className="entenda-quadro-texto">
                  <strong>Seu contrato está em dia?</strong>
                  <br />
                  Conheça a <b>reorganização</b>
                </p>
                <p className="entenda-quadro-texto">
                  Acesse nossa Área do Cliente, clique no card "Reorganização" e confira as ofertas
                  que temos disponíveis para você que está em dia.
                </p>
              </div>
              <a
                href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=renegociacao:card&int_campaign=area-do-cliente"
                target="_blank"
                className="entenda-quadro-link"
              >
                Acessar Área do Cliente
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default Renegociacao25Entenda;
